import { useTranslation } from "react-i18next";
import { NS } from "@core/libs/i18n/namespaces";

export const useTranslate = () => {
  const { t } = useTranslation(NS.WORKSPACE);
  return { t };
};
